<template>
  <div class="firs-day-of-week-block">
    <v-layout pa-2 mt-2>
      <v-flex>
        <v-card>
          <v-card-title>
            <i class="material-icons light-blue--text">attach_money</i>
            <div class="headline">&nbsp;Please choose default currency for billing:</div>
          </v-card-title>
            <v-layout row wrap >
              <v-flex xs12 sm12 md12 lg8 pa-2 mb-2 >
                <v-form ref="change_password" data-vv-scope="change_password" lazy-validation>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-radio-group v-model="currency" class="my-0 px-2">
                        <v-radio label="USD, Dollars" value="2"></v-radio>
                        <v-radio label="NIS, Shekels" value="1"></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-form>
                <v-btn color="primary" class="submit"
                  @click="changeCurrency()"
                  :loading="loading"
                  :disabled="loading"
                >Save currency</v-btn>
              </v-flex>
            </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'ChangeCurrencyBlock',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      loading: false,
      currency: this.$store.state.user.currency + ''
    }
  },
  methods: {
    changeCurrency () {
      this.loading = true
      this.$store.dispatch('SET_USER_CURRENCY', parseInt(this.currency)).then(res => {
        this.$store.dispatch('GET_USER_DATA')
        this.loading = false
        this.$toasted.show((parseInt(this.currency) === 1 ? 'Shekels' : 'Dollars') + ' was set as default currency')
      }, err => {
        this.loading = false
        console.log('SET_USER_CURRENCY error', err)
        this.$toasted.show('SET_USER_CURRENCY Error: ' + this.$services.getApiError(err), { type: 'error' })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/ChangeCurrencyBlock.vue